export let TotalsChartColors = {
  inductivo: '#105567',
  inductivoCompared: '#20a1c1',
  capacitivo: '#cbdc92',
  capacitivoCompared: '#9da875',
};
